import script from "./FormFieldCheckbox.vue?vue&type=script&setup=true&lang=js"
export * from "./FormFieldCheckbox.vue?vue&type=script&setup=true&lang=js"

import "./FormFieldCheckbox.vue?vue&type=style&index=0&id=677f6f38&lang=scss&scoped=true"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-677f6f38"]])

export default __exports__